export default __webpack_public_path__ + "static/media/StoreBag.b36fffb6.jpg";